export const featureHookKeys = {
    contactUsCta: "hook_modal.contact_us.cta",

    speakWithUsCta: "si.hook.cta.speak-with-us",

    userInterestedCta: "si.hook.cta.user-interested",

    exploringNextTitle: "si.hook.title.exploring-next",

    modalSuccessTitle: "hook_modal.get_feature.success.title",
    modalSuccessSubtitle: "si.modal.get_feature.success.subtitle.v-2",

    conversionRate: {
        search: {
            upgradeTitle: "si.hook.conversion_rate.upgrade.search.title",
            upgradeDescription: "si.hook.conversion_rate.upgrade.search.description",
        },
        company: {
            upgradeTitle: "si.hook.conversion_rate.upgrade.company.title",
            upgradeDescription: "si.hook.conversion_rate.upgrade.company.description",
        },
        column: {
            header: "si.hook.conversion_rate.upgrade.column.header",
            upgradeTitle: "si.hook.conversion_rate.upgrade.column.title",
            upgradeDescription: "si.hook.conversion_rate.upgrade.column.description",
        },
    } as const,
} as const;
